var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from '@emotion/styled';
import { Flex, theme } from '@robinpowered/ui-kit';
import { useEventDetailContext, } from '../../context/EventDetailContextProvider';
import { useEventApi } from '../../../hooks/useEvent/useEventApi';
import { useConfig } from '../../../context/ConfigContext';
import { RejectionModal } from './RejectionModal';
import { useApprovalPermission } from '../../../hooks/useApprovalPermission';
import { ReservationApprovalStatus } from './ReservationApprovalStatus';
import { useTranslation } from 'react-i18next';
import { EventDetailsSuccessActions } from '../../types';
export var SpaceRequest = function (_a) {
    var _b;
    var reservationApproval = _a.reservationApproval, space = _a.space;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var _c = useEventDetailContext(), onError = _c.onError, loadEvent = _c.loadEvent, onSuccess = _c.onSuccess;
    var _d = useConfig(), environmentUrls = _d.environmentUrls, userContext = _d.userContext, tenantId = _d.tenantId, accessToken = _d.accessToken;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var _e = __read(useState(false), 2), showRejectModal = _e[0], setShowRejectModal = _e[1];
    var _f = __read(useState(false), 2), showApprovalButtons = _f[0], setShowApprovalButtons = _f[1];
    var _g = __read(useState(false), 2), submittingApproval = _g[0], setSubmittingApproval = _g[1];
    var _h = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        accessToken: accessToken,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
    }), approveEventRequest = _h.approveEventRequest, rejectEventRequest = _h.rejectEventRequest;
    var managedSpaceId = String(space.id);
    var orgIdForPermission = (_b = currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id) !== null && _b !== void 0 ? _b : tenantId;
    var _j = useApprovalPermission({
        orgId: orgIdForPermission,
        managedSpaceId: managedSpaceId,
    }), canApprove = _j.canApprove, approvalPermissionLoading = _j.loading;
    var handleApprove = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmittingApproval(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, approveEventRequest(reservationApproval.reservation_id).then(function (res) {
                            var _a;
                            if (res === null || res === void 0 ? void 0 : res.approved) {
                                loadEvent();
                                onSuccess(EventDetailsSuccessActions.APPROVE_EVENT);
                            }
                            else if ((res === null || res === void 0 ? void 0 : res.approved) === false) {
                                onError(new Error((_a = res === null || res === void 0 ? void 0 : res.approval_notes) !== null && _a !== void 0 ? _a : t('errors.failed_to_approve_event_request')));
                            }
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setSubmittingApproval(false);
                    setShowApprovalButtons(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(SpaceRequestWrapper, { token: token, vertical: true, gap: 8, children: [_jsx(ReservationApprovalStatus, { reservationApproval: reservationApproval, hasApprovalPermission: canApprove, permissionLoading: approvalPermissionLoading, showApprovalButtons: showApprovalButtons, setShowApprovalButtons: setShowApprovalButtons, submittingApproval: submittingApproval, onApprove: handleApprove, onOpenRejectModal: function () { return setShowRejectModal(true); } }), _jsx(RejectionModal, { open: showRejectModal, eventId: reservationApproval.reservation_id, onSubmit: function () {
                    setShowRejectModal(false);
                    setShowApprovalButtons(false);
                    loadEvent();
                    onSuccess(EventDetailsSuccessActions.REJECT_EVENT);
                }, onError: onError, onCancel: function () { return setShowRejectModal(false); }, rejectEventRequest: rejectEventRequest })] }));
};
var SpaceRequestWrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  padding: 12px;\n"], ["\n  border-top: 1px solid ", ";\n  padding: 12px;\n"])), function (_a) {
    var token = _a.token;
    return token.colorBorderSecondary;
});
var templateObject_1;
